import { render, staticRenderFns } from "./UpdatesPreferences.vue?vue&type=template&id=57f20b98&scoped=true"
import script from "./UpdatesPreferences.vue?vue&type=script&lang=ts"
export * from "./UpdatesPreferences.vue?vue&type=script&lang=ts"
import style0 from "./UpdatesPreferences.vue?vue&type=style&index=0&id=57f20b98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f20b98",
  null
  
)

export default component.exports